module.exports = __webpack_public_path__ + "img/historia8.08077721.jpg";